export default [{
  path: '/dashboard-tv',
  name: 'dashboard-tv',
  component: () => import('./DashboardTV'),
  meta: {
    resource: 'dashboard-tv',
    actions: ['read']
  }
}]
